module.exports = __webpack_public_path__ + "static/media/popup-framing.76adae1d.png";